module.exports = __webpack_public_path__ + "img/comercial.a97a4338.webp";